//styling
import { useEffect, useRef } from "react"
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"

//Assessment components
import QuestionInput from "./QuestionInput"
import elementTypes from "../Elements/elementTypes"

export default function Question({
  previewMode,
  disabled,
  question,
  conditionalConfig,
  answers,
  onSetAnswer,
  isSelected,
}) {
  const questionRef = useRef()
  let displaySetting = true
  let requiredSetting = question.required

  let questionWidth = "100%"
  let questionTextWidth = "100%"
  let questionTextAlignment = "left"

  const useHelperText =
    question.helpText || previewMode
      ? question.helpText
      : "No help text specified"

  const isPlaceHolderHelpText = !question.helpText

  const useQuestionText =
    question.text || previewMode ? question.text : "No label specified"

  const isPlaceHolderText = !question.text

  let Text = <>{useQuestionText}</>

  const GetDescriptionText = ({ className }) => {
    return <label className={className}>{question.text}</label>
  }

  if (
    [elementTypes.headingElementId, elementTypes.descriptionElementId].includes(
      question.type
    )
  ) {
    questionTextWidth = question.width || "100%"
    questionTextAlignment = question.optionAlignment

    switch (question.height) {
      case 1:
        Text =
          elementTypes.headingElementId === question.type ? (
            <h3>{useQuestionText}</h3>
          ) : (
            <GetDescriptionText
              className={assessStyles.descriptionElementSmall}
            />
          )
        break
      case 2:
        Text =
          elementTypes.headingElementId === question.type ? (
            <h2>{useQuestionText}</h2>
          ) : (
            <GetDescriptionText
              className={assessStyles.descriptionElementMedium}
            />
          )
        break
      case 3:
        Text =
          elementTypes.headingElementId === question.type ? (
            <h1>{useQuestionText}</h1>
          ) : (
            <GetDescriptionText
              className={assessStyles.descriptionElementLarge}
            />
          )
        break
      default:
        break
    }
  }

  if (question.conditionalSource && previewMode) {
    if (conditionalConfig) {
      requiredSetting = conditionalConfig.required
      displaySetting = conditionalConfig.display
    } else if (question.conditionalDisplay) {
      displaySetting = false
    }
  }

  useEffect(() => {
    if (isSelected && questionRef.current) {
      const rect = questionRef.current.getBoundingClientRect()

      //Check if the question is in the viewport
      const isVisible =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)

      if (!isVisible) {
        questionRef.current?.scrollIntoView()
      }
    }
  }, [isSelected, questionRef])

  if (!displaySetting) {
    return null
  }

  return (
    <div
      className={`${assessStyles.questionLayout} ${
        myStyles.formBuilderQuestion
      } ${
        isPlaceHolderHelpText && isPlaceHolderText && previewMode
          ? assessStyles.noMarginBottom
          : ""
      }`}
      ref={questionRef}
      style={{ width: questionWidth }}
    >
      <div
        className={`${assessStyles.questionLayoutName} ${
          [
            elementTypes.headingElementId,
            elementTypes.descriptionElementId,
          ].includes(question.type)
            ? assessStyles.noMarginBottom
            : ""
        } ${
          isPlaceHolderHelpText && isPlaceHolderText && previewMode
            ? assessStyles.noMarginBottom
            : ""
        }`}
      >
        <div
          className={` ${questionTextAlignment} ${
            isPlaceHolderText ? myStyles.placeHolder : ""
          }`}
          style={{ width: questionTextWidth }}
        >
          {Text}
          {requiredSetting ? (
            <span className={assessStyles.required}>{" *"}</span>
          ) : null}
          <div>
            <small
              style={{ color: isPlaceHolderHelpText ? "lightgray" : "gray" }}
            >
              {useHelperText}
            </small>
          </div>
        </div>
      </div>
      <div
        className={`${assessStyles.questionLayoutBody} ${
          question.optionAlignment === "horizontal"
            ? assessStyles.horizontalQuestion
            : ""
        } ${!previewMode ? myStyles.questionLayoutBodyEditMode : ""} ${
          question.type === elementTypes.matrixElementId
            ? myStyles.questionMatrixEditMode
            : ""
        }`}
      >
        <QuestionInput
          question={question}
          answers={answers}
          onSetAnswer={onSetAnswer}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
